module.exports = __webpack_public_path__ + "img/geruda_from_tibet.b8a2e761.jpg";